export const pidakatBaseData = {
    my: {
        title: "ပိဋကတ် အခြေပြုပညာရေး",
        subtitle: "စနစ်တကျ အဆင့်ဆင့် သင်ကြားပို့ချခြင်း",
        grades: [
            {
                id: "saddha",
                name: "သဒ္ဓါဝဍ္ဎနတန်း",
                path: "/education/pidakat-base/saddha"
            },
            {
                id: "pre",
                name: "မူကြိုတန်း",
                path: "/education/pidakat-base/Pre"
            },
            {
                id: "primary",
                name: "မူလတန်း",
                path: "/education/pidakat-base/primary"
            },
            {
                id: "upaca",
                name: "ဥပစာတန်း",
                path: "/education/pidakat-base/upaca"
            }
        ],
        examSchedule: {
            title: "၆-လပတ် အတန်းတင် စာမေးပွဲကျင်းပချိန်",
            periods: [
                "ကဆုန်လပြည့်ကျော် (၁၊ ၂၊ ၃၊ ၄) ရက် ၁-ကြိမ်",
                "တန်ဆောင်မုန်းလပြည့်ကျော် (၁၊ ၂၊ ၃၊ ၄) ရက် ၁-ကြိမ်"
            ],
            frequency: "တစ်နှစ်လျှင် ၂-ကြိမ် နှစ်စဉ်ကျင်းပရန်",
            note: "ကဆုန်လဆန်း ၁၄-ရက်နှင့် တန်ဆောင်မုန်းလဆန်း ၁၄-ရက်တို့၌ အာဂုံရေးဖြေ ကျင်းပရန်နှင့် အာဂုံရေးဖြေအောင်မှ စာမေးပွဲ ဖြေခွင့်ပေးရန်"
        },
        summary: {
            title: "အခြေခံတန်း ၄-တန်း၌ သင်ယူရသော ကျမ်းစာများ",
            books: [
                "ရုပ်ပုံရှင်ကျင့်ဝတ်",
                "ရတနာ့ဂုဏ်ရည်",
                "အခြေပြုသဒ္ဒါ (တွဲဖက်)",
                "အခြေပြုသဒ္ဒါသုတ်နက်",
                "အဘိဓမ္မတ္ထသင်္ဂဟပါဌ်",
                "အခြေပြုသင်္ဂြိုဟ်",
                "ပါဠိသိက္ခာနှင့် သဒ္ဒါအကျဉ်း",
                "ဓမ္မပဒအဋ္ဌကထာ (ပထမအုပ်)",
                "ဝိနည်း မဟာဝါပါဠိတော်",
                "အင်္ဂုတ္တိုရ်ပါဠိတော် (ပထမအုပ်)"
            ],
            note: "နိဿယ စာအုပ်၊ အဓိပ္ပါယ်စာအုပ် စသော အစွယ်အပွား အခြံအရံ ကျမ်းစာတို့ပါထည့်လျှင် ဤမျှမကပေ။"
        }
    },

    en: {
        title: "Pitaka-Based Education",
        subtitle: "Systematic Step-by-Step Learning",
        grades: [
            {
                id: "saddha",
                name: "Saddhāvaḍḍhana Grade",
                path: "/education/pidakat-base/saddha"
            },
            {
                id: "pre",
                name: "Preparatory Grade",
                path: "/education/pidakat-base/Pre"
            },
            {
                id: "primary",
                name: "Primary Grade",
                path: "/education/pidakat-base/primary"
            },
            {
                id: "upaca",
                name: "Upaca Grade",
                path: "/education/pidakat-base/upaca"
            }
        ],
        examSchedule: {
            title: "Bi-annual Examination Schedule",
            periods: [
                "First Period: 1st to 4th day after Full Moon of Kason",
                "Second Period: 1st to 4th day after Full Moon of Tazaungmon"
            ],
            frequency: "Conducted twice annually",
            note: "Oral examinations are held on the 14th waxing day of Kason and Tazaungmon. Students must pass the oral examination to be eligible for the written examinations."
        },
        summary: {
            title: "Books Studied in 4 Basic Grades",
            books: [
                "Rupasingkyintwut (Monastic Etiquette)",
                "Ratana Gunye (Qualities of the Triple Gems)",
                "Basic Grammar (Supplementary)",
                "Basic Grammar Thutnet",
                "Abhidhammatthasangaha Pali",
                "Basic Sangaha",
                "Pali Sikkha and Concise Grammar",
                "Dhammapada Atthakatha (Volume 1)",
                "Vinaya Mahavagga Pali",
                "Anguttara Pali (Volume 1)"
            ],
            note: "This list would be even longer if we included supplementary materials like Nissaya books and interpretation texts."
        }
    }
};